// Axios wrapper
import axios, { AxiosInstance } from 'axios';
import { IRestClient } from './Interfaces/IRestClient';

export class RestClient implements IRestClient {
  private client: AxiosInstance;

  constructor(baseURL: string, headers?: Record<string, string>) {
    this.client = axios.create({ baseURL, headers, timeout: 15000 });
  }

  // FIXED GET METHOD (config only)
  async get<T>(path: string, config?: any) {
    const r = await this.client.get<T>(path, config);
    return r.data;
  }

  // POST stays as is
  async post<T>(path: string, body?: any, config?: any) {
    const r = await this.client.post<T>(path, body, config);
    return r.data;
  }
}
